<template>
    <div
        :class="['dropdown-item', {'active': selected, 'hover': highlighted}, ...classes]"
        @click="$emit('click', {text, value})"
        @mouseover="$emit('mouseover', {text, value})"
    >
        <slot>{{ text }}</slot>
    </div>
</template>

<script>
    /**
     * @group Inputs
     * The DropdownItem component used within the Dropdown component.
     */
    export default {
        name: 'DropdownItem',
        props: {
            /**
             * The text that appears as the dropdown item
             */
            text: {
                type: String,
                required: false,
                default() {
                    return "";
                }
            },
            /**
             * The value of the dropdown item
             */
            value: {
                type: [String, Number],
                required: true,
            },
            /**
             * Boolean specifying if this item is selected
             */
            selected: {
                type: Boolean,
                required: false,
            },
            /**
             * Boolean specifying if this item is highlighted
             */
            highlighted: {
                type: Boolean,
                default: false,
                required: false,
            },
            /**
             * Optionally pass classes to this dropdown item
             */
            classes: {
                type: [Array, Object],
                required: false,
                // `[]`
                default() {
                    return [];
                },
            },
        },
    };
</script>

<style
    lang="sass"
    scoped
>
    .dropdown-item
        white-space: normal !important

        &:hover
            cursor: pointer
</style>
